export default __webpack_public_path__ + "static/media/project9.76f7954b.webp";